import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/rent-object-locations/rent-objects/${formData.rentObjectId}`, formData);
  },
  async findAll() {
    return axios.get(`/rent-object-locations`);
  },
  async find(formData) {
    return axios.get(`/rent-object-locations/rent-objects/${formData.rentObjectId}`);
  },
  async delete({ id }) {
    return axios.delete(`/rent-object-locations/${id}`);
  }
};